import { render } from "./restyle_footer.vue?vue&type=template&id=988345a2&scoped=true"
import script from "./restyle_footer.vue?vue&type=script&lang=js"
export * from "./restyle_footer.vue?vue&type=script&lang=js"

import "./restyle_footer.vue?vue&type=style&index=0&id=988345a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988345a2"]])

export default __exports__